import React from 'react';
import { useAuth } from '../context/AuthContext';
import AntiguedadSaldos, { descargarAntiguedad } from '../components/AntiguedadSaldos';
import SelectorMoneda, { useVistaMoneda } from '../components/reportes/SelectorMoneda';
import Exportar from '../components/reportes/Exportar';
import EncabezadoImpresion from '../components/reportes/EncabezadoImpresion';
import BotonAyuda from '../components/BotonAyuda';

// Antigüedad de cuentas por cobrar (#117): reporte aparte de la pantalla
// Cuentas por cobrar, que es la lista factura por factura.
export default function ReporteAntiguedadPorCobrar() {
  const { empresaActiva, empresaActivaNombre } = useAuth();
  const [verEn, setVerEn] = useVistaMoneda();

  return (
    <div className="space-y-6">
      <EncabezadoImpresion titulo="Antigüedad de cuentas por cobrar" detalle={`Montos en ${verEn}`} />
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between print:hidden">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">
            Antigüedad de cuentas por cobrar
            {empresaActivaNombre && <span className="text-slate-400 font-normal"> · {empresaActivaNombre}</span>}
            <BotonAyuda />
          </h1>
          <p className="text-sm text-slate-500 mt-1">Antigüedad de lo que deben los clientes, contada desde el vencimiento de cada factura.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          <SelectorMoneda vista={verEn} onChange={setVerEn} />
          <Exportar
            onExcel={() => descargarAntiguedad('/facturas', 'excel', verEn)}
            onPdf={() => descargarAntiguedad('/facturas', 'pdf', verEn)}
          />
        </div>
      </div>

      <AntiguedadSaldos base="/facturas" etiquetaParte="Cliente" empresaActiva={empresaActiva} verEn={verEn} />
    </div>
  );
}
